import * as Analysis from '../../../services/AnalysisService';

import { DEFAULT_PAGE_SIZE } from '../../../constants';

export const FETCH_ANALYSES = 'FETCH_ANALYSES';
export const FETCH_ANALYSIS = 'FETCH_ANALYSIS';
export const SAVE_ANALYSIS = 'SAVE_ANALYSIS';
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION';
export const SET_DOCUMENT_SELECTION = 'SET_DOCUMENT_SELECTION';
export const DOCUMENT_SELECT_MODE = 'DOCUMENT_SELECT_MODE';
export const SET_ACTIVE_DOCUMENT_ID = 'SET_ACTIVE_DOCUMENT_ID';
export const SET_DOCUMENT_SELECTION_NOTFOUND = 'SET_DOCUMENT_SELECTION_NOTFOUND';
export const SUSPEND_ANALYSIS = 'SUSPEND_ANALYSIS';
export const FETCH_ANALYSIS_COMPLETE_USER_STATS = 'FETCH_ANALYSIS_COMPLETE_USER_STATS';
export const FETCH_CURRENT_ANALYSIS_STATS = 'FETCH_CURRENT_ANALYSIS_STATS';
export const DELETE_ANALYSIS = 'DELETE_ANALYSIS';
export const PATCH_ANALYSIS = 'PATCH_ANALYSIS';

// ACTION GENERATORS
export const fetchAnalysesAction = (
    search = null,
    status = null,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE
) => ({
    type: FETCH_ANALYSES,
    payload: Analysis.fetchAnalyses(search, status, pageNumber, pageSize),
});

const fetchAnalysisAction = () => ({
    type: FETCH_ANALYSIS,
    payload: Analysis.fetchAnalysis(),
});

const fetchAnalysisAuditByIdAction = analysisId => ({
    type: FETCH_ANALYSIS,
    payload: Analysis.fetchAnalysisAuditById(analysisId),
});

const saveAnalysisAction = analysis => ({
    type: SAVE_ANALYSIS,
    payload: Analysis.saveAnalysis(analysis),
});

const setCurrentQuestionAction = question => ({
    type: SET_CURRENT_QUESTION,
    payload: question,
});

const setDocumentSelectionAction = (start, end, text, documentId) => ({
    type: SET_DOCUMENT_SELECTION,
    payload: { start: start, end: end, text: text, documentId: documentId },
});

const setDocumentSelectModeAction = selectMode => ({
    type: DOCUMENT_SELECT_MODE,
    payload: selectMode,
});

const clearDocumentSelectionAction = () => ({
    type: SET_DOCUMENT_SELECTION,
    payload: { start: null, end: null, text: null },
});

const setActiveDocumentIdAction = activeDocumentId => ({
    type: SET_ACTIVE_DOCUMENT_ID,
    payload: activeDocumentId,
});

const setDocumentSelectionNotFoundAction = notFound => ({
    type: SET_DOCUMENT_SELECTION_NOTFOUND,
    payload: notFound,
});

const suspendAnalysisAction = (analysisId, reason) => ({
    type: SUSPEND_ANALYSIS,
    payload: Analysis.suspendAnalysis(analysisId, reason),
});

const fetchAnalysisCompleteUserStatsAction = (
    startDate = null,
    endDate = null,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE
) => ({
    type: FETCH_ANALYSIS_COMPLETE_USER_STATS,
    payload: Analysis.fetchAnalysisCompleteUserStats(startDate, endDate, pageNumber, pageSize),
});

const patchAnalysisReviewAction = propertiesToPatch => ({
    type: PATCH_ANALYSIS,
    payload: Analysis.patchAnalysisReview(propertiesToPatch),
});

const deleteAnalysisAction = analysisId => ({
    type: DELETE_ANALYSIS,
    payload: Analysis.deleteAnalysis(analysisId),
});

const fetchCurrentAnalysisStatsAction = () => ({
    type: FETCH_CURRENT_ANALYSIS_STATS,
    payload: Analysis.fetchCurrentAnalysisStats(),
});

// EXPORT ACTIONS
export {
    fetchAnalysesAction as fetchAnalyses,
    fetchAnalysisAction as fetchAnalysis,
    saveAnalysisAction as saveAnalysis,
    setCurrentQuestionAction as setCurrentQuestion,
    setDocumentSelectionAction as setDocumentSelection,
    setDocumentSelectModeAction as setDocumentSelectMode,
    clearDocumentSelectionAction as clearDocumentSelection,
    setActiveDocumentIdAction as setActiveDocumentId,
    setDocumentSelectionNotFoundAction as setDocumentSelectionNotFound,
    fetchAnalysisAuditByIdAction as fetchAnalysisAuditById,
    suspendAnalysisAction as suspendAnalysis,
    fetchAnalysisCompleteUserStatsAction as fetchAnalysisCompleteUserStats,
    patchAnalysisReviewAction as patchAnalysisReview,
    deleteAnalysisAction as deleteAnalysis,
    fetchCurrentAnalysisStatsAction as fetchCurrentAnalysisStats,
};
